// BASENAME FOR FILE DOWNLOAD
var basename = function( path ) {
	return path.split('?')[0].split('#')[0].split('/').reverse()[0];
}

// DOWNLOAD FILE AND SET TO HUBSPOT
var download_file = function( file ){
	if( user_data.hbsp.fields.email ) {
		var ajax_data = {
			'action'			: 'hubspot-asset',
			'key'				: 'ef10041ea9e6dec01f36e8a0f3cb2b4212d7c7f4',
			'email'				: user_data.hbsp.fields.email,
			'website_asset'		: file
		};
		$.ajax({
			url		: '/wp-admin/admin-ajax.php',
			type	: 'GET',
			data	: ajax_data,
			success	: function(result){
				// SUBMIT WEBSITE ASSET FORM
				$('#website-asset-form').find('[name="email"]').val( user_data.hbsp.fields.email );
				$('#website-asset-form').find('[name="last_asset_download"]').val( basename( file ) );
				$('#website-asset-form form').submit();
			}
		});
	}
	set_dataLayer({
		'event'		: 'download',
		'action'	: 'click',
		'label'		: basename( file )
	});
	
	if( file && file.includes( '.pdf' ) ) {
		window.open( file, '_blank' );
	} else {
		window.location.href = file;
	}
}

$(document).on('click', '[href*=".pdf"]:not([data-gated-hubspot]),[href*=".zip"]:not([data-gated-hubspot])', function(e){
	e.preventDefault();
	download_file( $(this).attr('href') );
})

// CLICK TO OPEN MODAL FORM OR DOWNLOAD GATED HUBSPOT CONTENT
$('[data-gated-hubspot]').on('click', function(e){
	e.preventDefault();
	var $gated_elem = $($(this).attr('data-gated-element'));
	if( user_data.hbsp.forms.length == 0 ) {
		user_data.gate_content = {
			'$elem'		: $gated_elem,
			'download'	: $gated_elem.is('[download]')
		};
		if( $('#modal-product').length > 0 ) {
			$.fancybox.open({
				src  : '#modal-product'
			});
		}
		set_dataLayer({
			'event'		: 'launch gated hubspot modal',
			'action'	: 'click'
		});
	} else {
		download_file( $gated_elem.attr('href') );
	}
});

var ungate_content = function(){
	$('[data-gated-hubspot]').each(function(){
		var $gated_elem = $($(this).attr('data-gated-element'));
		$(this).attr('href', $gated_elem.attr('href'));
	})
}

$(document).ready(function(){
	if( user_data && user_data.hbsp.forms.length > 0 ) {
		ungate_content();
	}
});

// HUBSPOT FORM
$.fn.setup_hubspot_form_from_wrapper = function() {
	if( $(this).attr('data-hubspot-form') ) {
		if( ! $(this).attr('id') ) $(this).attr('id', 'hubspot-form--' + $(this).attr('data-hubspot-form'));
		var hubspot_vars = {
			portalId	: '6634299',
			formId		: $(this).attr('data-hubspot-form'),
			target		: '#' + $(this).attr('id'),
			cssRequired	: false,
			locale		: $('html').attr('lang'),
			onFormReady : function(form) {
				if( $(form).is(':visible') || $(form).closest('.modal').length > 0 || $(form).is('[data-form-id="bae9882a-6b1c-4e49-bf8b-96614cb3088a"]') ) {
					$(form).find('select').each(function(){
						let text = $(this).val() ? $(this).find('option[value="' + $(this).val() + '"]').text() : $(this).find('option[selected]').text();
						$(this).wrap('<div class="select-wrap"></div>');
						$(this).closest('.select-wrap').prepend('<div class="placeholder">' + text + '</div>');
					});
					$(window).trigger('resize');
					
					// POPULATE INDUSTRY FROM USER STORAGE
					if( user_data.industry ) {
						$('[name="lee_industry"]').val(user_data.industry.title);
					}
	
					// POPULATE PRODUCT NAME
					if( $('[data-product-name]').length > 0 ) {
						$(form).find('[name="product"]').val( $('[data-product-name]').text() );
					}
				}
			},
			onFormSubmit : function(form) {

				// ADD URL HIDDEN FIELD
				if( $(form).find('[name="form_submission_url_test_2"]').length > 0 ) {
					var currentUrl = location.protocol + '//' + location.host + location.pathname + location.search + location.hash;
					$(form).find('[name="form_submission_url_test_2"]').val(currentUrl);
				}
				
				// LEGACY PRODUCT FINDER
				if( $(form).is('[data-form-id="bae9882a-6b1c-4e49-bf8b-96614cb3088a"]') ) {
					var summary = [];
					$('.summary_of_inputs .selection-content').each(function(){
						summary.push( $(this).text() );
					});
					var summary_text = summary.join('; ');
					$('[name="summary_of_your_inputs"]').val( summary_text );
					return false;
				}
				
				// PART NUMBER
				if( $('#part-number-request').is(':visible') ) {
					
					// ADDED TO PART NUMBER
					$('#part-number-request').addClass('submitted');
					
					// REINIT
					setTimeout(function(){
						$('#part-number-request [data-hubspot-form]').setup_hubspot_form_from_wrapper();
					}, 1000);

					// CLOSE
					setTimeout(function(){
						$.fancybox.close();
					}, 5000);

					// SWITCH BACK
					setTimeout(function(){
						$('#part-number-request').removeClass('submitted');
					}, 5750);
				}

				if( user_data ) {
	
					// ADD USER FIELDS TO user_data OBJECT
					$.each( user_data.hbsp.fields, function(key, value){
						var $field = $(form).find('[name="' + key + '"]');
						if( $field.length ) {
							user_data.hbsp.fields[key] = $field.val();
						}
					});

					// HUBSPOT LEGAL CONSENT
					$.each($(form).serializeArray(), function(key, field) {
						if( field.name.indexOf( 'LEGAL_CONSENT' ) !== -1 ) {
							user_data.hbsp.consent[field.name] = field.value;
						}
					})

					// ADD FORM ID TO user_data OBJECT
					user_data.hbsp.forms.push( form[0].id );
					save_user_data();

					// UNGATE CONTENT AFTER A FORM HAS BEEN SUBMITTED;
					ungate_content();

					// GATED CONTENT DOWNLOAD
					if( user_data.gate_content ) {
						set_dataLayer({
							'event'		: 'form submit',
							'action'	: 'click',
							'label'		: 'gated download'
						});

						download_file( user_data.gate_content['$elem'].attr('href') );
						if( $('#modal-product').is(':visible') ) {
							$('#modal-product').addClass('submitted');

							setTimeout(function(){
								$.fancybox.close();
							}, 3500);

							setTimeout(function(){
								$('#modal-product').removeClass('submitted');
							}, 4250)
						}
					}
				}
			},
			onFormSubmitted : function(form) {
				// REBUILD WEBSITE ASSET DOWNLOAD FORM
				if( $(form).is('.hs-form-60d7bab6-2a86-4145-823e-2e2936206df7') ) {
					setTimeout(function(){
						$('[data-hubspot-form="60d7bab6-2a86-4145-823e-2e2936206df7"]').setup_hubspot_form_from_wrapper();
					}, 750)
				}
			}

		};

		if( $(this).attr('data-css') !== undefined ) hubspot_vars.css = $(this).attr('data-css');
		hbspt.forms.create(hubspot_vars);
	}
}

// HUBSPOT FORMS INITIALIZATION
$('[data-hubspot-form]').each(function(){
	$(this).setup_hubspot_form_from_wrapper();
});


// UPDATE PART VALUE TO HUBSPOT FORM
$(document).on('click', '[data-request-part]', function(){
	var part = $(this).attr('data-request-part');
	$('[data-part-number]').text(part);
	setTimeout(function(){
		$('#part-number-request').find('[name="part_number"]').val( part ).attr('value', part);
	}, 50 );
})